import React from 'react';
import Post from './post';
import Sectiontitle from "./sectiontitle";

import usePost from '../hooks/use-post';

const Posts = () => {

    const posts = usePost();

    return (  
        <section id="posts" className="bg-light">
            <div className="container py-5">
                <Sectiontitle title="Posts"/>
                <div className="card-columns">
                    {posts.map(post => (
                        <Post 
                            key={post.id}
                            post={post}
                        />
                    ))}                
                </div>
            </div>
        </section>
    );
}
 
export default Posts;